import CryptoJS from 'crypto-js';

export function getHashedFileName(name: string, extension: string): string {
  const fileName = new Date().getTime() + name;
  const hashedName = CryptoJS.SHA1(fileName).toString(CryptoJS.enc.Hex);
  return `${hashedName}.${extension}`;
}
